export default __webpack_public_path__ + "static/media/angle-small-right.090c73a0.svg";